import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NetworkMonitorService {
  private readonly STORAGE_KEY = 'lastOnlineUrl';
  private readonly allWorkspaceId = environment.allWorkspaceId;

  private get FALLBACK_URL(): string {
    return `/home/${this.allWorkspaceId}`;
  }

  constructor(
    private connectionService: ConnectionService,
    private router: Router
  ) {}

  public startMonitoring(): void {
    this.connectionService.monitor().subscribe((currentState: ConnectionState) => {
      const isOnline = currentState.hasNetworkConnection;
      const isOnDisconnectionPage = this.router.url.includes('/disconnection');

      if (!isOnline) {
        if (!isOnDisconnectionPage) {
          localStorage.setItem(this.STORAGE_KEY, this.router.url);
          this.router.navigate(['/disconnection']);
        }
      } else {
        if (isOnDisconnectionPage) {
          const lastUrl = localStorage.getItem(this.STORAGE_KEY);
          const targetUrl = lastUrl || this.FALLBACK_URL;

          this.router.navigateByUrl(targetUrl).then(() => {
            // localStorage.removeItem(this.STORAGE_KEY);
          });
        }
      }
    });
  }
}
